import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ProcessSection from '../../components/feature/ProcessSection';
import PhilosophySection from '../../components/feature/PhilosophySection';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import ContactSection from '../../components/feature/ContactSection';
import ServicesSection from '../../components/feature/ServicesSection';
import MidPageCTA from '../../components/feature/MidPageCTA';
import LocationMapSection from './components/LocationMapSection';
import LocalAreasSection from './components/LocalAreasSection';

const LOCATION_FAQS = [
  {
    q: 'Who offers luxury interior design services near Beverly Hills?',
    a: 'Lisa Merkle Design is the premier luxury interior design studio in Beverly Hills, California. Formally trained at UCLA and with years at LA\'s top celebrity design firms, Lisa leads high-end residential and commercial projects throughout Beverly Hills, Los Angeles, and nationwide for discerning clients.',
  },
  {
    q: 'What interior design services are available in Beverly Hills and Los Angeles?',
    a: 'Lisa Merkle Design offers a comprehensive suite including full home design, kitchen and bathroom design, renovation consultation, bedroom and living room design, lighting selection, art procurement, furniture customization, space planning, and much more — serving all of Beverly Hills and greater Los Angeles.',
  },
  {
    q: 'How do I find a luxury interior designer in Los Angeles?',
    a: 'Lisa Merkle Design serves clients throughout Beverly Hills, West Hollywood, Bel Air, Malibu, Santa Monica, and greater Los Angeles. Contact our Beverly Hills studio at (323) 745-2205 or submit the consultation form to schedule your private design consultation at 215 N La Peer Dr, Beverly Hills.',
  },
  {
    q: 'Does Lisa Merkle Design serve areas beyond Beverly Hills?',
    a: 'Yes — our Beverly Hills studio serves clients throughout Los Angeles including West Hollywood, Pacific Palisades, Brentwood, Malibu, Bel Air, Santa Monica, Westwood, Hancock Park, Encino, and more. We also work with clients nationwide, leading luxury projects across the entire United States.',
  },
  {
    q: 'What is the address for Lisa Merkle Design in Beverly Hills?',
    a: 'Lisa Merkle Design is located at 215 N La Peer Dr, Beverly Hills, CA 90211. Reach us by phone at (323) 745-2205 or by email at lisa@lisamerkledesign.com. We serve clients throughout greater Los Angeles and accept luxury design projects across the United States.',
  },
];

export default function LocationPage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection
          badge="Beverly Hills Interior Design"
          title="Interior Design in Beverly Hills,"
          titleItalic="Los Angeles & Nationwide"
          subtitle="215 N La Peer Dr, Beverly Hills, CA 90211 · (323) 745-2205"
          description="Serving Beverly Hills, Los Angeles, and discerning clients across the US with luxury residential interior design, renovation consultation, and full home transformations."
          bgImage="https://lisamerkledesign.com/wp-content/uploads/2026/03/bg.png"
          ctaText="Schedule a Consultation"
          ctaLink="/location#contact"
          secondaryCtaText="Call (323) 745-2205"
          secondaryCtaLink="tel:+13237452205"
        />
        <TrustBar />
        <LocationMapSection />
        <LocalAreasSection />
        <MidPageCTA
          heading="Serving Beverly Hills & All of Los Angeles."
          subtext="Schedule your private consultation at our Beverly Hills studio — or virtually from anywhere."
          ctaText="Request a Consultation"
          bgColor="charcoal"
        />
        <AIAnswerBlock
          eyebrow="Beverly Hills Interior Design"
          heading="Luxury Interior Design in Beverly Hills, Los Angeles & Across the US"
          what="A Beverly Hills-based luxury interior design studio offering residential and commercial services throughout Los Angeles and nationwide. From our studio at 215 N La Peer Dr, Beverly Hills, we lead projects of every scale — single rooms to full estate transformations."
          who="Homeowners, property investors, architects, and developers in Beverly Hills, Los Angeles, and greater Southern California. Our clients are discerning individuals who understand world-class design is an investment that enhances life and protects long-term property value."
          services="Beverly Hills Luxury Homes · Los Angeles Residences · Bel Air Estates · Malibu Coastal Properties · West Hollywood Residences · Pacific Palisades Homes · Santa Monica · Westwood · Hancock Park · Encino · Nationwide"
          benefits="Local Beverly Hills expertise, deep knowledge of the LA luxury market, trusted trades network throughout Southern California, and the editorial credibility of Elle Décor and Architectural Digest recognition."
          why="Beverly Hills demands the highest design standard. Lisa Merkle's UCLA training, celebrity firm experience, and editorial publications make her one of the most qualified luxury designers in this market."
          highlights={['Beverly Hills', 'West Hollywood', 'Bel Air', 'Malibu', 'Pacific Palisades', 'Santa Monica', 'Los Angeles', 'Nationwide']}
        />
        <ProcessSection />
        <PhilosophySection />
        <ServicesSection limit={12} title="Services in Beverly Hills & LA" subtitle="Design Services for Your Home" />
        <ServiceAreasSection />
        <TestimonialsSection />
        <MidPageCTA
          heading="Your Beverly Hills Design Studio is Ready."
          subtext="Join our distinguished list of clients throughout Los Angeles and beyond."
          ctaText="Schedule a Design Consultation"
          bgColor="warm"
        />
        <FAQSection faqs={LOCATION_FAQS} eyebrow="Local Questions" heading="Beverly Hills Interior Design FAQ" />
        <FinalCTA
          title="Your Beverly Hills Design Studio"
          subtitle="Schedule your private consultation at our Beverly Hills studio or contact us to discuss your project anywhere in the US."
          ctaText="Schedule a Design Consultation"
          bgImage="https://lisamerkledesign.com/wp-content/uploads/2022/12/294079553_3977893455667930_7592458361888613885_n.jpg"
        />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
